
import { useEffect, useRef, useState } from "react";
import { useTareas } from "../../../hooks/tareas/useTareas";
import { ContenedorParametros } from "../../components/utils/ContenedorParametros"
import { ContenedorTabla } from "../../components/utils/ContenedorTabla"
import { Tooltip } from "../../components/utils/Tooltip";
import { BotonProcesar } from "../../components/buttons/BotonProcesar";
import { useActividades } from "../../../hooks/actividades/useActividades";
import { DatePickerABX } from "../../components/pickers/DatePicker";
import { Modal } from "../../components/modal/Modal";
import { calcularHorasTranscurridas, formatDate, obtenerHoraActual } from "../../../utils/utils";
import { useModal } from "../../../hooks/useModal";

export const Tareas = () => {
    const classNameInput = 'caret-white lg:text-xs px-2 rounded w-full bg-zinc-900 focus:outline-none focus:ring-1 focus:ring-blue-500';
    const [ actividadElegida , setActividadElegida ] = useState(0);
    const [ iniciarAuto, setIniciarAuto ] = useState(false)
    const [ fechaInicioEjecucion, setFechaInicioEjecucion ] = useState('')
    const [ time, setTime ] = useState('')
    const [ isOpenModalInfo, openModalInfo, closeModalInfo ] = useModal(null);
    const [ isOpenPausarActividad, openModalPausarActividad, closeModalPausarActividad ] = useModal(false);
    const [ tiempoActividadSegundos, setTiempoActividadSegundos ] = useState('');
    const [ fechaUltimaPausa, setFechaUltimaPausa ] = useState('');
    const {
        nuevaTarea,
        editarValorNuevaTarea,
        listarTareas,
        tareas,
        editarValorTarea,
        registrarTarea,
        listaActividadPorUsuario,
        actividadUsuario,
        listaDetallePorTicketActividad,
        detalleTicket
    } = useTareas();

    const {
        editarValorInicioFinActividad,
        inicioFinActividad,
        cambiarEstadoActividad,
        openModalValidarEstado,
        isOpenModalValidarEstado,
        closeModalValidarEstado,
        listarTipoPausa,
        tipoPausa,
        pausarActividadConMotivo,
        editarValorActividadPausa,
        finalizarActividadPausada
    } = useActividades()

    const obtenerColorPorEstado = (codEstado) => {
        switch(codEstado){
            case 9: return 'bg-yellow-500';
            case 48: return 'bg-green-500';
            default: return 'bg-cyan-500'
        }
    }

    const registrarNuevaTarea = async (indice) => {
        const isValid = await registrarTarea(indice);
        if(isValid)
        {
            editarValorNuevaTarea('descripcionTarea','')
            listarTareas(actividadElegida)    
        }
    }

    const registrarInicioFinActividad = async () => {
        const isValid = await cambiarEstadoActividad();
        if(isValid){
            closeModalValidarEstado()
            await listaActividadPorUsuario()
            await listarTareas(actividadElegida)
        }
    }

    const asignarDataActividad = async (actividad) => {
        editarValorInicioFinActividad('nomActividad',actividad.nomActividad);
        editarValorInicioFinActividad('codTicketActividad',actividad.codTicketActividad);
        editarValorInicioFinActividad('codEstadoTicketActividad',actividad.codEstado);
        editarValorInicioFinActividad('fecha',formatDate(new Date()));
        editarValorInicioFinActividad('hora',obtenerHoraActual());
    }

    const validarIniciarActividad = async () => {
        iniciarAuto ? registrarInicioFinActividad() : openModalValidarEstado()
    }

    const guardarFinActividadPausada = async (codTicketActividad) => {
        const isValid = await finalizarActividadPausada(codTicketActividad);
        if(isValid){
            await listaActividadPorUsuario()
            await listarTareas(actividadElegida)
        }
    }

    const guardarActividadPausada =async () => {
        const isValid  = await pausarActividadConMotivo()
        if(isValid){
            await listaActividadPorUsuario()
            await listarTareas(actividadElegida)
            closeModalPausarActividad()
        }
    }

    useEffect(() => {
        listaActividadPorUsuario();
        listarTipoPausa();
    },[])

    useEffect(() => {
        if(actividadUsuario.length > 0){
            const actividadEnProceso = actividadUsuario.find(act => act.codEstado === 48)
            const comprobarActividad = actividadUsuario.find(act => act.codTicketActividad === actividadElegida)
            setTiempoActividadSegundos(actividadEnProceso ? actividadEnProceso.totalSegundosActividad : ' ')
            setFechaInicioEjecucion(actividadEnProceso ? actividadEnProceso.fechaInicioReal : '')
            setFechaUltimaPausa(actividadEnProceso ? actividadEnProceso.ultimaFechaHoraFinPausa : '')
            if(actividadElegida === 0){
                setActividadElegida(actividadUsuario[0].codTicketActividad)
                editarValorActividadPausa('codTicketActividad',actividadUsuario[0].codTicketActividad)
            }
            else{
                comprobarActividad ? setActividadElegida(actividadElegida) : setActividadElegida(actividadUsuario[0].codTicketActividad)
            }
        }
        else{
            setActividadElegida(0)
        }
    },[actividadUsuario]);

    useEffect(() => {
        actividadElegida !== 0 && listarTareas(actividadElegida)
        editarValorNuevaTarea('descripcionTarea','')
    },[actividadElegida])

    useEffect(() => {
        const timer = setInterval(() => {
            if(fechaInicioEjecucion !== ''){
                setTime(prev => calcularHorasTranscurridas(tiempoActividadSegundos,fechaUltimaPausa !== '' ? fechaUltimaPausa : fechaInicioEjecucion))
            }
        }, 1000)
        return () => {
            clearInterval(timer)
        }
    }, [fechaInicioEjecucion])

    return(
        <>
            <ContenedorParametros titulo="Tareas del personal">
                <BotonProcesar onClick={() => listaActividadPorUsuario()}/>
            </ContenedorParametros>
            <ContenedorTabla>
                <div
                    className="w-full h-full flex flex-col gap-y-4"
                >
                    <div
                        className="w-full h-[10%] overflow-auto containerScroll grid grid-flow-col auto-cols-max gap-3 min-h-[80px] items-center"
                    >
                        {
                            actividadUsuario.length > 0 ? 
                                actividadUsuario.map((act, i) => (
                                    <section
                                        key={act.codTicketActividad}
                                        className={`px-2 py-1 rounded border border-zinc-300 gap-x-1 gap-y-2 h-[70px] justify-center w-[290px]
                                            grid grid-cols-[minmax(0,90fr)_minmax(0,10fr)] grid-rows-2 cursor-pointer
                                            ${actividadElegida === act.codTicketActividad ? 'bg-[#112441]' : ' bg-[#2e5289] '}
                                            
                                        `}
                                        onClick={()=> {
                                            setActividadElegida(act.codTicketActividad)
                                            editarValorActividadPausa('codTicketActividad',act.codTicketActividad)
                                        }}
                                        // onTouchStart={}
                                    >
                                        <div className="flex items-center">
                                            <span
                                                className={`${obtenerColorPorEstado(act.codEstado)} lg:text-xs rounded text-center cursor-pointer min-w-[43px]`}
                                                // onClick={()=> { setActividadElegida(act.codTicketActividad)}}
                                            >{act.codTicketActividad}</span>
                                            <span data-tip={act.codTicketActividad + '_'}
                                                data-for={act.codTicketActividad + '_'}
                                                className={`hover:bg-blue-800 px-2 rounded lg:text-xs whitespace-nowrap
                                                text-ellipsis overflow-hidden cursor-pointer`}
                                                // onClick={()=> { setActividadElegida(act.codTicketActividad)}}
                                            >{act.nomActividad}</span>
                                            <Tooltip id={act.codTicketActividad + '_'}>{act.nomActividad}</Tooltip>
                                        </div>
                                        <section
                                            key={'cad-Actividad' + i}
                                            data-indice={i}
                                            data-tip={'detalleTicket'}
                                            data-for={'detalleTicket'}
                                            className={`row-span-2 flex items-center justify-center rounded hover:bg-blue-800 cursor-pointer`}
                                            onClick={async () => {
                                                await listaDetallePorTicketActividad(act.codTicketActividad)
                                                openModalInfo()
                                            }}
                                        >
                                            <i className="fa fa-info"></i>
                                        </section>
                                        <Tooltip id={'detalleTicket'}>Ver detalle del ticket</Tooltip>
                                        <section className="py-1 flex gap-x-2 items-center">
                                            {
                                                (act.codEstado === 9 || act.codEstado === 56 ) && act.existeActividadEnProceso === 0 ? 
                                                    <>
                                                        <button
                                                            className="fa fa-play bg-green-600 px-2 py-1 rounded text-xs"
                                                            onClick={async () => {
                                                                if(act.codEstado === 9){
                                                                    await asignarDataActividad(act)
                                                                    await validarIniciarActividad()
                                                                }
                                                                else{
                                                                    guardarFinActividadPausada(act.codTicketActividad)
                                                                }
                                                            }}
                                                        ></button>
                                                    </>
                                                : 
                                                    (act.codEstado === 48 ?  
                                                        <div
                                                            key={'cont_' +act.codTicketActividad}
                                                            className="flex gap-2"
                                                        >
                                                            <button
                                                                className="fa fa-stop bg-red-600 px-2 py-1 rounded text-xs"
                                                                onClick={async () => {
                                                                    await asignarDataActividad(act)
                                                                    await validarIniciarActividad()
                                                                }}
                                                            ></button>
                                                            <button
                                                                className="fa fa-pause bg-yellow-600 px-2 py-1 rounded text-xs"
                                                                onClick={async () => {
                                                                    await asignarDataActividad(act)
                                                                    editarValorActividadPausa('codTicketActividadPausaTipo',tipoPausa[0].codTicketActividadPausaTipo)
                                                                    openModalPausarActividad()
                                                                    // await asignarDataActividad(act)
                                                                    // await validarIniciarActividad()
                                                                }}
                                                            ></button> 
                                                            
                                                        </div>
                                                        : ''
                                                    )
                                            }
                                            {
                                                act.codEstado === 48 ?  
                                                <section className="flex items-center gap-x-2 ">
                                                    <i className="fa fa-regular fa-clock"></i>
                                                    <span>{time}</span>
                                                </section>
                                                : ''
                                            }
                                        </section>
                                        
                                        
                                    </section>
                                ))
                            : ''
                        }

                    </div>
                    
                    <div className={`w-full overflow-y-auto containerScroll h-[90%]`}>
                        <div className={`text-center  ${actividadElegida !== 0 ? ' hidden ' : ' '}`}>
                            <span className="text-2xl">No tiene actividades pendientes...</span>
                        </div>
                        <table className={`table ${actividadElegida === 0 ? ' hidden ' : ''}`}>
                            <thead>
                                <tr>
                                    <th>N</th>
                                    <th>COD</th>
                                    <th className="text-left">DESCRIPCIÓN</th>
                                    <th>FECHA REGISTRO</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr key={'trParaRegistro'}>
                                    <td colSpan={4} className="text-center">
                                        <input
                                            className={`${classNameInput}`}
                                            placeholder="Escriba aquí su tarea..."
                                            value={nuevaTarea.descripcionTarea}
                                            onChange={(e) => editarValorNuevaTarea('descripcionTarea',e.target.value)}
                                            onKeyUp={(e) => {
                                                if(e.keyCode === 13)
                                                {
                                                    if(e.target.value !== '')
                                                    {
                                                        registrarNuevaTarea()
                                                    }
                                                }
                                            }}
                                            enterKeyHint="enter"
                                            onFocus={() => editarValorNuevaTarea('codTicketActividad',actividadElegida)}
                                        />
                                    </td>
                                </tr>
                                {
                                    tareas.length > 0 ?
                                        tareas.map((t,i) => (
                                            <tr>
                                                <td className="text-center w-[3%]">{i+1}</td>
                                                <td className="text-center w-[5%]"><span className="bg-blue-600 rounded px-2">{t.codTicketTarea}</span></td>
                                                <td className="text-center">
                                                    <input
                                                        value={t.descripcionTarea}
                                                        className={`${classNameInput} bg-transparent border-none`}
                                                        onChange={(e) => {
                                                            editarValorTarea(i, 'descripcionTarea', e.target.value)
                                                        }}
                                                        onKeyUp={(e) => {
                                                            if(e.keyCode === 13)
                                                            {
                                                                if(e.target.value !== '')
                                                                {
                                                                    registrarNuevaTarea(i)
                                                                }
                                                            }
                                                        }}
                                                        enterKeyHint="enter"
                                                    />
                                                </td>
                                                <td className="text-center">{t.fechaCreacion}</td>
                                            </tr>
                                        ))
                                    : ''
                                        // <tr><td colSpan={4} className="text-center">No hay información para mostrar...</td></tr>
                                }
                            </tbody>
                        </table>
                    
                    </div>
                </div>
                
            </ContenedorTabla>

            <Modal 
                isOpen={isOpenModalValidarEstado}
                closeModal={closeModalValidarEstado}
                textButtons={{
                    confirm: 'Si',
                    denied: 'No'
                }}
                title={`[ ${inicioFinActividad.codTicketActividad} ] ${inicioFinActividad.codEstadoTicketActividad === 9 ? 'Iniciar ' : 'Finalizar '} Actividad`}
                action={()=> registrarInicioFinActividad()}
            >
                    <div className='h-[200px] flex flex-col gap-2'>
                        <div className='border rounded'>
                            <div className='w-full py-1 '>
                                <div className='flex w-full gap-2  justify-center text-lg font-bold p-2  rounded'>
                                    <span className='w-[90px]'>Actividad</span>
                                    <span className=''>:</span>
                                    <span className='whitespace-nowrap text-ellipsis overflow-hidden w-[350px]'>{inicioFinActividad.nomActividad}</span>
                                </div>
                            </div>
                            <div className='w-full py-3'>
                                <div className='flex w-full gap-2 px-2 text-lg font-bold'>
                                    <span className='w-[90px]'>Fecha</span>
                                    <span>:</span>
                                    <div className='flex gap-2'>
                                        <div className='w-[120px]'>
                                            <DatePickerABX
                                                date={inicioFinActividad.fecha}
                                                setDate={editarValorInicioFinActividad}
                                                classNameInput={'lg:w-[70px] lg:text-xs lg:p-[2px]  bg-zinc-900 border border-zinc-600'}
                                                keyDate='fecha'
                                                ocultarIcono={true}
                                            />
                                        </div>
                                        <input 
                                            type='time'
                                            className={`${classNameInput} p-2 h-[30px] text-sm bg-zinc-900`}
                                            value={inicioFinActividad.hora}
                                            onChange={(e) => editarValorInicioFinActividad('hora',e.target.value)}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='flex flex-col items-center gap-2 py-3'>
                            <img
                                src='https://upload.wikimedia.org/wikipedia/commons/1/11/Blue_question_mark_icon.svg'
                                className='w-[40px] h-[40px]'
                                alt=''
                            />
                            <span className='text-lg'>¿Esta seguro de realizar la operación ?</span>
                        </div>

                    </div>

            </Modal>

            <Modal
                title={`[ ${detalleTicket[0].codTicket} ] Ticket: ${detalleTicket[0].nomTicket}`}
                isOpen={isOpenModalInfo}
                closeModal={closeModalInfo}
                validButton={{denied: true, confirm:false}}
                textButtons={{denied: 'Cerrar'}}
            >
                <fieldset className="border border-zinc-600 rounded p-2 w-[700px]">
                    <legend>Información del ticket</legend>
                        <div className="grid grid-cols-[minmax(0,2fr)_minmax(0,8fr)] px-3 items-center gap-x-2 gap-y-2 min-h-[100px] max-h-[350px] overflow-y-auto containerScroll">
                            <span className="font-medium">Entregable</span>
                            <spa>{detalleTicket[0].nomEntregable}</spa>
                            <hr className="border border-zinc-600 col-span-2"></hr>
                            <span className="font-medium">Alcance</span>
                            <spa>{detalleTicket[0].alcance}</spa>
                            <hr className="border border-zinc-600 col-span-2"></hr>
                            <span className="font-medium">Objetivo</span>
                            <spa> {detalleTicket[0].objetivo}</spa>
                            {/* <hr className="border border-zinc-600 col-span-2"></hr> */}
                        </div>
                </fieldset>
            </Modal>

            {/* MODAL PARA PAUSAR ACTIVIDAD */}
            <Modal
                title={`[${actividadElegida}] Pausar actividad `}
                isOpen={isOpenPausarActividad}
                closeModal={closeModalPausarActividad}
                action={()=> guardarActividadPausada()}
            >
                <div className=''>
                    <label>Motivo</label>
                    <select
                        className={`min-h-[40px] ${classNameInput}`}
                        onChange={(e) => editarValorActividadPausa('codTicketActividadPausaTipo',e.target.value)}
                    >
                        {
                            tipoPausa.length > 0 ? 
                                tipoPausa.map(tipo => (
                                    <option key={tipo.codTicketActividadPausaTipo} value={tipo.codTicketActividadPausaTipo}>{tipo.nomActividadPausaTipo}</option>
                                ))
                            : ''
                        }
                    </select>
                </div>
            </Modal>
        </>
    )

}